import 'jquery';
import { Amplitude } from '../Shared/amplitude';

function setActiveTab($carousel: JQuery<HTMLElement>) {
	if (window.location.hash) {
		const $activeTabLink = $carousel.find('.nav-link[href="' + window.location.hash + '"]');

		if ($activeTabLink.length) {
			$carousel.find('.nav .nav-item').removeClass('active');
			$activeTabLink.parent().addClass('active');

			const slide = $activeTabLink.parent().data('slide-to');
			$carousel.carousel(slide);
		}
	}
}

export default function initCarousel(carouselId: string, carouselTag: string, tabActivator: (hash: string) => void = null) {
	const $carousel = $(carouselId);

	if (!$carousel.length)
		return;

	setActiveTab($carousel);

	$carousel.on('slide.bs.carousel', function (e) {
		$carousel.find('.nav .nav-item').eq(e.to).addClass('active');

		let hash = $carousel.find('.nav .nav-item').eq(e.to).find('.nav-link').attr('href');
		window.location.hash = hash;

		let eventData: any = {
			'Tab': hash
		};

		const projectName = $('#project-name').val();
		if (projectName)
			eventData['Project'] = projectName;

		Amplitude.logEvent(`${carouselTag} - Tab`, eventData);

		if (tabActivator != null)
			tabActivator(hash);

	}).on('slid.bs.carousel', function (e) {
		$carousel.find('.nav .nav-item').eq(e.from).removeClass('active');
	});
}